import 'material-design-icons-iconfont/dist/material-design-icons.css'

import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

import VueRouter from 'vue-router'
import VeeValidate from 'vee-validate';

import i18nPlugin, { loadLocale } from './plugins/i18n'
import GlobalTranslator from './plugins/global_translator'

import './actioninterface.js';
import {globalMixin} from './global_mixin'

// Disable console log in production
// if (process.env.NODE_ENV === 'production') {
//     console.log = function () {};
// }

Vue.use(VueRouter);
Vue.use(VeeValidate);

Vue.use(vuetify, {
  iconfont: 'md'
});

Vue.use(i18nPlugin);
Vue.use(GlobalTranslator);

// English is always preloaded as the fallback. The user's saved language
// comes from the Android bridge ("LocalData" / "appLanguage") and is fetched
// inside the root Vue instance's created() hook below — by then guidWeb()
// and the other Vue.prototype helpers are wired up, and `this` is a real
// Vue instance rather than Vue.prototype.
loadLocale('en');

Vue.config.productionTip = false

/*global AndroidRoutingTest*/
if(typeof AndroidRoutingTest !== "undefined" && AndroidRoutingTest !== null){
  Vue.prototype.deviceInfo = JSON.parse(AndroidRoutingTest.getDeviceInfo());
}
else{
  console.log('device api not defined');
}

import loginForm from '@/components/registration/login'
// import activateBusiness from '@/components/registration/activate_business'
import signupForm from '@/components/registration/signup'
import otpVerification from '@/components/registration/otp_verification'
import setupDrive from '@/components/registration/set_backup_drive'
import restoreData from '@/components/registration/restore_data'

import userType from '@/components/registration/user_type'
import apitest from '@/components/registration/apitest'

import languageView from '@/components/registration/language'

// import userLanding from '@/components/registration/user_landing'

const router = new VueRouter({
    // base:'/registration/',
    routes:[
        { path: '/', redirect: '/registration/business/language'},
        { path: '/registration/business/language', name:'languageView', component:languageView},
        { path: '/registration/business/login', name:'loginForm', component:loginForm},
        // { path: '/registration/business/activate', name:'activateBusiness', component:activateBusiness},
        { path: '/registration/business/register', name:'signupForm', component:signupForm},
        { path: '/registration/business/verifycode', name:'otpVerification', component:otpVerification},
        { path: '/registration/business/setupdrive', name:'setupDrive', component:setupDrive},
        { path: '/registration/business/restore_data', name:'restoreData', component:restoreData},
        { path: '/registration/business/usertype', name:'userType', component:userType},

        { path: '/registration/business/apitest', name:'apitest', component:apitest},
        // { path: '/registration/business/user_landing', name:'userLanding', component:userLanding},
    ],
    mode: 'history'
});

Vue.prototype.guidWeb = function(){
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

Vue.prototype.fn_fixBackgroundScroll = function () {
  let scroll_y = window.scrollY;
  let parentContainer = document.getElementsByClassName('parent-container')[0];
  document.getElementsByTagName("body")[0].classList.add("noscroll");

  parentContainer.classList.add("scrollauto-y");

  parentContainer.scrollTop = scroll_y;
}

Vue.prototype.fn_removeFixBackgroundScroll = function (spy) {
  let parentContainer = document.getElementsByClassName('parent-container')[0];
  document.getElementsByTagName("body")[0].classList.remove("noscroll");
  parentContainer.classList.remove("scrollauto-y");

  let scroll_y = 0;
  spy ? scroll_y = spy : '';

  setTimeout(function() {
    window.scrollTo(0, scroll_y);
  },100);
}

new Vue({
  vuetify,
  router,
  data: {
    selectedLanguage: null
  },
  // created: function(){
  //   var self = this;
  //   this.fn_getLocalData('appLanguage', function(response){
  //     if(!response || response === 'null') return;
  //     let langObj = null
  //     try { 
  //       langObj = JSON.parse(response); 
  //     } catch(e) { /* plain string */ }
  //     if (!langObj || langObj === 'null' || (langObj && !langObj.language)) return;
  //     self.$loadLocale(langObj.language).then(function(){
  //       self.selectedLanguage = langObj.language;
  //     });
  //   });
  // },
  render: h => h(App),
  mixins: [globalMixin]
}).$mount('#app')
